import {IconButton, Tooltip} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const MapPopperButton = ({tooltip, tooltipPosition, disabled, ...props}) => (
  <Tooltip title={tooltip} placement={tooltipPosition}>
    {disabled ? (
      // Adding a span is a recommended hack for disabled buttons: https://mui.com/material-ui/react-tooltip/#disabled-elements
      <span>
        <IconButton disabled={disabled} {...props} />
      </span>
    ) : (
      <IconButton {...props} />
    )}
  </Tooltip>
);

MapPopperButton.propTypes = {
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipPosition: PropTypes.string,
};

export default MapPopperButton;
